import { calculateEntryAmount } from '@/services/utils';
angular.module('leanlaw').controller('ProductivityDetailCtrl', ['$scope', '$window', '$q', '$filter', '$stateParams', '$rootScope', 'alerts', 'userService', 'reportsService', 'exportJson', 'singleRequest', 'leanLawApi', 'messageBus', function ($scope, $window, $q, $filter, $stateParams, $rootScope, alerts, userService, reportsService, exportJson, singleRequest, leanLawApi, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  // The repeat expression used to create this as a side effect of assigning
  // data.filteredEntries; $parse builds missing objects on assignment.
  $scope.data = {};
  $scope.search = '';
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.title = $stateParams.report;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const exp = $scope.data.filteredEntries.reduce((accum, e) => {
      let exportEntry = {
        Date: new Date(e.date).toNetworkDate(),
        Description: e.description,
        'Hours Non-Billable': $filter('hoursDecimal')(!e.billingType === 'billable' ? e.hours : 0)
      };
      exportEntry['Fixed Fee Hours'] = $filter('hoursDecimal')(e.billingType == 'fixedFee' ? e.hours : 0);
      exportEntry = {
        ...exportEntry,
        'Hours Worked': $filter('hoursDecimal')(e.billingType === 'billable' ? e.hours : 0),
        'Hours Write-down': $filter('hoursDecimal')(e.billingType === 'billable' ? e.writedown : 0),
        'Hours Billable': $filter('hoursDecimal')(e.billingType === 'billable' ? e.billedHours : 0),
        Rate: $filter('hoursDecimal')(e.billingType === 'billable' || e.billingType == 'fixedFee' ? e.rate : 0),
        'Billable Amount ': e.billingType == 'fixedFee' ? 'N/A' : $filter('amount')(e.billingType === 'billable' ? e.amount : 0)
      };
      accum.push(exportEntry);
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.return = function () {
    $window.history.back();
  };
  activate();

  /////////////////////////////

  function activate() {
    $q.all([userService.me(), leanLawApi.getAccount({
      id: $stateParams.userId
    })]).then(([me, user]) => {
      $scope.me = me;
      $scope.user = user;
      $scope.$on('commonFilterService-statechanged', (event, payload) => {
        if (!payload) return;
        // Assigning to existing filter keeps custom filter options
        $scope.filter = Object.assign($scope.filter, payload);
        // Necessary to set this value for the requests
        $scope.filter.status = $scope.filter.archived.status;
        // if (payload.filter.range) filterClientEntries();
        filter();
      });
      $scope.$on('report-sidebar-filterchange', (event, payload) => {
        $scope.filter = Object.assign($scope.filter, payload);
      });

      // MessageBus is used here so that the commonFilter module can pick it up once it loads
      messageBus.addMessage('filterDependency-ready', true);
    });
  }
  function filter() {
    $scope.loading = true;
    const query = reportsService.queryFromFilter($scope.filter);
    query.data = 'services,hours';
    query.account = $scope.user.id;
    query.clientId = $stateParams.clientId;
    query.matterId = $stateParams.matterId;
    singleRequest.apiCall('report').listEntries(query).then(list => {
      if (!list) return;
      $scope.data.entries = list.entries.map(e => ({
        date: $scope.me.features?.dateHandling && e.localDateTime?.date ? e.localDateTime.date : e.startTime,
        description: e.description,
        amount: e.billingType === 'billable' ? calculateEntryAmount(e.rate.amount, e.billedHours) : 0,
        hours: e.hours,
        writedown: e.billingType === 'billable' ? e.hours - e.billedHours : 0,
        rate: e.rate ? e.rate.amount : 0,
        billed: e.billed,
        account: e.account,
        matter: e.matter,
        billedHours: e.billedHours,
        billingType: e.billingType
      }));
    }).catch(err => {
      alerts.error(err);
    }).finally(() => {
      $scope.loading = false;
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel('report');
    deactivate();
  });

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredEntries = $filter('orderBy')($filter('filter')($scope.data.entries, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.entries', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);